<template>
  <div class="content">
    <SystemPageList :systemPageList="systemPageList" :systemPageListTitle="systemPageListTitle" :itemSubtitleNeeded="false" />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';

  definePageMeta({ middleware: 'check-token' });

  const store = useMainStore();
  const route = useRoute();
  const categories = computed(() => store.categories);
  const systemPageList = computed(() => {
    return categories.value
      .filter((category) => route.params.category == category.nodeId)
      .map((item) => ({
        nodeId: item.nodeId,
        id: item.id,
        external: typeof item.external === 'object' ? item.external : undefined,
        internal: undefined,
        title: item.title,
        nodes:
          item.nodes?.map((node) => ({
            id: node.id,
            nodeId: node.nodeId,
            external: typeof node.external === 'object' ? node.external : undefined,
            internal: undefined,
            title: node.title,
            resources: node.resources || []
          })) || []
      }));
  });
  const systemPageListTitle = computed(() => {
    // Replace with actual logic for setProperFieldExternalFirst if needed
    return systemPageList.value[0]?.title || '';
  });
</script>
